export default {
  load_error_title: "Error al cargar el documento",
  load_error_subtitle:
    "Lo sentimos, no se pudo cargar el documento. Por favor intente nuevamente más tarde.",
};
